import { z } from "zod";

export const rejectNoteSchema = z.object({
  rejectionReason: z
    .string()
    .min(1, "Rejection reason is required")
    .max(1500, "Rejection reason cannot exceed 1500 characters"),
});

export type RejectNoteFormValues = z.infer<typeof rejectNoteSchema>;

export const approveCosignSchema = z.object({
  acknowledgment_details: z.string().max(1000, "Cannot exceed 1000 characters").optional(),
  isConfirmed: z.boolean().refine((v) => v, "You must confirm before co-signing"),
});

export type ApproveCosignFormValues = z.infer<typeof approveCosignSchema>;
